import React from 'react';
import { AppRouter } from './app/router/AppRouter';
import { useAppBootstrap } from './app/bootstrap/useAppBootstrap';
import { AppAntdProvider } from './app/providers/AppAntdProvider';
import GlobalStyle from './styles/GlobalStyle';
import { themeObject } from './styles/themes/themeVariables';
import { useAppSelector } from './hooks/reduxHooks';

const App: React.FC = () => {
  const theme = useAppSelector((state) => state.theme.theme);

  useAppBootstrap();

  return (
    <>
      <meta name="theme-color" content={themeObject[theme].primary} />
      <GlobalStyle />
      <AppAntdProvider>
        <AppRouter />
      </AppAntdProvider>
    </>
  );
};

export default App;
